import {AssistanceApplicationType} from '../../services/api.client';

export const ApplicationTypeRouteMap: { [key in AssistanceApplicationType]: string } = {
    [AssistanceApplicationType.UHONS]: 'uhons',
    [AssistanceApplicationType.UFF]: 'uff',
    [AssistanceApplicationType.STLWater]: 'stlwater',
    [AssistanceApplicationType.EFN]: 'efn',
    [AssistanceApplicationType.STLStorm]: 'stlstorm'
};
